import { GET_MATCHING_LAB_VITALS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type LabVitalsResponse = LabVital[];

export interface LabVital {
    id: string;
    name: string;
    unit_dislay_name?: string;
    all_units?: AllUnitsEntity[] | null;
    is_panel?: boolean;
}
export interface AllUnitsEntity {
    name: string;
    id: string;
    refRange?: RefRange;
}
export interface RefRange {
    low?: string | null;
    high?: string | null;
}

export default (text?: string): Promise<LabVitalsResponse> =>
    fetchWithRefresh(
        GET_MATCHING_LAB_VITALS((text || '').replace(/[^a-zA-Z0-9 ]/g, '')),
    ).then((res) => res.json());
